<template>
    <design-2021-apprentice-radar-chart-component
        :options="chartOptions"
        :series="series"></design-2021-apprentice-radar-chart-component>
</template>

<script>
export default {
    name: 'design-2021-survey-results-index-chart-component',
    props: ['skillTreeIn'],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    height: 350,
                    width: '100%',
                    type: 'radar',
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    radar: {
                        size: 140,
                        polygons: {
                            strokeColors: '#e9e9e9',
                            fill: {
                                colors: ['#f8f8f8', '#fff'],
                            },
                        },
                    },
                },
                xaxis: {
                    categories: this.skillTreeIn.skills.map((skill) => skill.name),
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 5,
                },
            },
        };
    },
    methods: {
        processSkillTree(skillTree) {
            if (!skillTree) {
                return;
            }

            let series = {
                self: {
                    name: this.$t('survey.own'),
                    color: 'blue',
                    data: [],
                },
                students: {
                    name: 'Peers',
                    color: 'green',
                    data: [],
                },
                teachers: {
                    name: this.$t('survey.teachers'),
                    color: 'orange',
                    data: [],
                },
            };

            for (const skill of skillTree.skills) {
                let self_value = null;
                let students_value = null;
                let teachers_value = null;

                for (const form of skill.forms.toReversed()) {
                    if (form.values !== undefined && form.values.self.value !== null && !self_value) {
                        self_value = form.values.self.value;
                    }
                    if (form.values !== undefined && form.values.students.value !== null && !students_value) {
                        students_value = form.values.students.value;
                    }
                    if (form.values !== undefined && form.values.teachers.value !== null && !teachers_value) {
                        teachers_value = form.values.teachers.value;
                    }

                    if (self_value && students_value && teachers_value) {
                        break;
                    }
                }

                series.self.data.push(self_value);
                series.students.data.push(students_value);
                series.teachers.data.push(teachers_value);
            }

            this.series = [series.self, series.students, series.teachers];
            this.chartOptions = {
                ...this.chartOptions,
                ...{ xaxis: { categories: this.skillTreeIn.skills.map((skill) => skill.name) } },
            };
        },
    },
    watch: {
        skillTreeIn: function (skillTreeIn) {
            this.processSkillTree(skillTreeIn);
        },
    },
    mounted() {
        this.processSkillTree(this.skillTreeIn);
    },
};
</script>

<style scoped></style>
